module.exports = __webpack_public_path__ + "img/e-header-bg.51e3b724.png";